// Attach a live radio stream to an <audio> element.
//   • Icecast MP3/AAC → set src directly (every browser).
//   • HLS (.m3u8) → native where supported (Safari/iOS), else lazy-load hls.js
//     (Chrome/Firefox) so the ~50 KB library never lands in the main bundle.
// Returns a cleanup fn to detach on unmount / url change.
export async function attachStream(audio: HTMLAudioElement, url: string): Promise<() => void> {
  const isHls = /\.m3u8(\?|$)/i.test(url);

  if (!isHls || audio.canPlayType("application/vnd.apple.mpegurl")) {
    audio.src = url;
    return () => {
      audio.removeAttribute("src");
      audio.load();
    };
  }

  const { default: Hls } = await import("hls.js");
  if (Hls.isSupported()) {
    const hls = new Hls({ enableWorker: true });
    hls.loadSource(url);
    hls.attachMedia(audio);
    return () => hls.destroy();
  }

  // Last resort: let the browser try.
  audio.src = url;
  return () => {
    audio.removeAttribute("src");
    audio.load();
  };
}
